import { Box, FilterListBox, Heading, Notice, Progress, Stack } from '@eleveo/components-react';
import { WithT } from 'i18next';
import React from 'react';
import { Trans } from 'react-i18next';

import { ASSIGN_QUEUE_CONTAINER_TAG, ASSIGN_QUEUE_FILTER_BOX_TAG, ASSIGN_QUEUE_HEADING_TAG } from './constants';
import { Center } from '../../components/LayoutNext/components/Center';
import { Agent } from '../../graphql/components';
import { fullNameOfAgent } from '../../utils/helpers';

export type QueuesBulkAssignFormProps = {
  agentsWithSkill: Agent[];
  assignedIds: string[];
  assignIds: (ids: string[]) => void;
  loading: boolean;
} & WithT;

export const QueuesBulkAssignForm: React.FC<QueuesBulkAssignFormProps> = ({
  agentsWithSkill,
  assignedIds,
  assignIds,
  loading,
  t,
}) => {
  // These data should be already sorted by name, surname
  const agentsData = agentsWithSkill.map((agent) => ({ ...agent, name: fullNameOfAgent(agent) }));

  return loading ? (
    <Center>
      <Progress />
    </Center>
  ) : (
    <Box padding={20} testId={ASSIGN_QUEUE_CONTAINER_TAG}>
      <Stack direction="vertical" className="w-full" spacing={25}>
        <Heading as="h3" className="text-blue-700" id={ASSIGN_QUEUE_HEADING_TAG}>
          {t('person.availablePeople')}
        </Heading>

        <Notice>
          <Trans i18nKey="queue.filteredPeopleWithSkill" components={[<strong key="0">people with skill</strong>]} />
        </Notice>

        <FilterListBox
          aria-labelledby={ASSIGN_QUEUE_HEADING_TAG}
          isBig
          items={agentsData}
          onSelectionChange={(keys) => assignIds([...keys] as string[])}
          selectionMode="multiple"
          selectedKeys={assignedIds}
          testId={ASSIGN_QUEUE_FILTER_BOX_TAG}
        />
      </Stack>
    </Box>
  );
};
